// extracted by mini-css-extract-plugin
export var navbarImg = "navigation-module--navbar-img--vvnOJ";
export var navbarImgLarge = "navigation-module--navbar-img-large--U2qbz";
export var navbarImgExtraLarge = "navigation-module--navbar-img-extra-large--GDg0L";
export var icon = "navigation-module--icon--Ns1Pd";